import React from 'react';
import Image from '@/components/Bicester/Image';
import { IconButton } from 'rsuite';

const Toolbar = ({
  title,
  handleReset,
  handleAdd,
}: {
  title?: string;
  handleReset?: () => void;
  handleAdd?: () => void;
}) => {
  return (
    <div className={`flex items-center h-[30px] ${title ? 'mb-[36px]' : ''}`}>
      {title && <div className="text-[20px] text-[#455255] mr-[30px]">{title}</div>}
      {handleReset && (
        <IconButton className="flex items-center mr-[30px]" onClick={handleReset}>
          <Image src="/resources/images/reset.svg" />
          <div className="text-[12px] text-[#999999] ml-[5px]">重置</div>
        </IconButton>
      )}
      {handleAdd && (
        <IconButton className="flex items-center" onClick={handleAdd}>
          <Image src="/resources/images/add.svg" />
          <div className="text-[12px] text-[#999999] ml-[5px]">新增</div>
        </IconButton>
      )}
    </div>
  );
};

export default Toolbar;
